// types
import { useEffect, useState } from 'react';
import {
  SelectComponentTypes,
  SelectItemProps,
  SelectListPosition,
  SelectType,
} from './types';

// components
import IconSelected from '../icons/selected';
import IconLoader from '../icons/loader';
import styles from './select.module.css';
import IconSearch from '../icons/search';

export default function OptionsList({
  list,
  handleSelectValue,
  selectValues,
  selectListPosition,
  isLoading,
  emptyContentButton,
  ulRef,
  onScroll,
  mode,
}: SelectComponentTypes): React.JSX.Element {
  const [filteredList, setFilteredList] = useState<SelectItemProps[]>([]);
  const [searchText, setSearchText] = useState('');

  const onSearch = (text: string) => {
    setSearchText(text);

    setFilteredList(
      list?.filter((item) =>
        item.name.toLowerCase()?.includes(text?.toLowerCase()),
      ),
    );
  };

  useEffect(() => {
    setFilteredList(list);
  }, [list]);

  return (
    <ul
      className={`${styles.selectList} ${
        selectListPosition === SelectListPosition.BOTTOM
          ? styles.bottomPosition
          : styles.topPosition
      } ${isLoading ? styles.listOverflowHidden : ''}`}
      role="menu"
      ref={ulRef}
      onScroll={onScroll}
    >
      {isLoading && (
        <li className={styles.listLoader}>
          <IconLoader />
        </li>
      )}
      {!isLoading && mode === SelectType.MULTIPLE && (
        <div className={styles.multipleSearchInputWrapper}>
          <IconSearch />
          <input
            type="text"
            name="searchInput"
            className={styles.multipleSearchInput}
            placeholder="Search value..."
            onChange={(e) => onSearch(e.target.value)}
            value={searchText}
          />
        </div>
      )}
      {filteredList?.length ? (
        filteredList?.map((item: SelectItemProps) => (
          <li
            key={item.value.toString()}
            role="menuitem"
            className={`select-item ${
              selectValues?.find(
                (selectedItem) =>
                  selectedItem.toString() === item.value.toString(),
              )
                ? styles.selected
                : ''
            }`}
          >
            <button
              type="button"
              onClick={() => handleSelectValue(item)}
              tabIndex={-1}
            >
              <div
                className={`${styles.selectItemItemTop} ${
                  !item.description ? styles.fullWidth : ''
                }`}
              >
                <span>{item.name}</span>

                <span className="select-item-top-right">
                  <span>{item.suffix || ''}</span>
                  {selectValues?.find(
                    (selected) => selected.toString() === item.value.toString(),
                  ) && <IconSelected />}
                </span>
              </div>
              {item.description && (
                <div className={styles.description}>{item.description}</div>
              )}
            </button>
          </li>
        ))
      ) : (
        <>
          <li role="menuitem">
            <div className={styles.emptyListItem}>Not found</div>
          </li>
          {emptyContentButton && <li role="menuitem">{emptyContentButton}</li>}
        </>
      )}
    </ul>
  );
}
